export const stringLimiter = (
	limit: number,
	input?: string,
): {
	limit: boolean;
	value: string | undefined;
} => {
	if (input && input.length > limit) {
		return {
			value: `${input.substring(0, limit)}...`,
			limit: true,
		};
	}
	return {
		value: input,
		limit: false,
	};
};
